import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { faqs } from "../data/content";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-90" data-mp="1gj3pi2323lu6">
      <div className="mx-auto max-w-3xl" data-id="element-91" data-mp="249g57z4jmmvb">
        <h2 id="faq-title" className="text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-92" data-mp="24ahima917lg7">
          Frequently asked <em className="text-wine-700" data-id="element-93" data-mp="28cm58p12bhtc">questions</em>
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-94" data-mp="1uiv7edwp1mdg">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-cream ring-1 ring-wine-100" data-id="element-95" data-mp="2n825xcw5ebyp" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[17px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-wine-600" data-id="element-96" data-mp="2rys9ckl0k4qr">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-wine-700 transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-97" data-mp="19tv9pqkfb4nn" />
                </button>
                <AnimatePresence initial={false} data-id="element-98" data-mp="1jmatmtfa63b6">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-99" data-mp="1xjfwylnm0o2q">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink-soft" data-id="element-100" data-mp="3ue2m6ohoq2dw">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-12" data-id="element-101" data-mp="287j240u2h9av">
          <CtaButton label="I'm ready to start training" data-id="element-102" data-mp="286hnxnhr86ox" />
        </div>
      </div>
    </section>;
}